import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { EnumService } from 'app/core/services/enum.service';
import { Roulette } from 'app/public/model/roulette.model';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { LogoLocation, LogoRotation, LogoShape, LogoSize } from 'app/shared/model/enums';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-roulette-logo-settings',
  templateUrl: './roulette-logo-settings.component.html',
  styleUrls: ['./roulette-logo-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteLogoSettingsComponent implements OnInit {
  @ViewChild('op') framPanel: OverlayPanel;
  logoShape = LogoShape;
  logoSize = LogoSize;
  logoLocation = LogoLocation;
  logoRotation = LogoRotation;

  @Input()
  roulette: Roulette;

  shapeOptions: string[];
  locationOptions: string[];
  rotationOptions: string[];
  sizeOptions: string[];
  deleteLogo:boolean=false;
  newLogoImage = null;

  get logoSettings() {
    return this.roulette?.Design.LogoSettings;
  }

  get logo(): string {
    if(this.deleteLogo==true)
      return null;
    return this.newLogoImage ? this.newLogoImage : this.logoSettings.LogoUrl;
  }
  set logo(value: string) {
    this.newLogoImage = value;
  }



  constructor(private _enumService: EnumService) { }

  ngOnInit(): void {
    this.shapeOptions = this._enumService.getEnumValues(LogoShape);
    this.locationOptions = this._enumService.getEnumValues(this.logoLocation);
    this.rotationOptions = this._enumService.getEnumValues(this.logoRotation);
    this.sizeOptions = this._enumService.getEnumValues(this.logoSize);

  }

  onChooseLogo(logoImage) {
    (this.logoSettings as any).newLogoImageAsBase64 = logoImage;
    this.deleteLogo=false
  }
  onDeleteLogo()
  {
    (this.logoSettings as any).IsDelete=true; 
    (this.logoSettings as any).newLogoImageAsBase64=null
    this.deleteLogo=true
  }
}
